/** The two ways a test run reaches tools, named, colored and explained the same on every surface. */

import type { SegmentedOption } from '@/modules/simulator/ui/segmented';
import type { RunMode } from '@/types/websocket.types';
import { counted } from '../format';

export const MODE_LABELS: Record<RunMode, string> = {
	simulated: 'Mocked',
	grounded: 'Live data'
};

/** A run's mode as a tag colors it, so Live data stands out from Mocked. */
export const MODE_TONES: Record<RunMode, string> = {
	simulated: 'text-gray-800',
	grounded: 'border-emerald-200 text-emerald-700'
};

export const MODE_OPTIONS: SegmentedOption<RunMode>[] = (['simulated', 'grounded'] as const).map((value) => ({
	value,
	label: MODE_LABELS[value]
}));

/** What each mode does with the tools. */
export const MODE_DESCRIPTIONS: Record<RunMode, string> = {
	simulated:
		"no tool is called: answers come from the real ticket's recording when it has one, else from the scenario world bent to the scenario type; judged against the human reply where there is one",
	grounded:
		'reads come from the live tools, bent to the scenario type, writes simulated, judged against the human reply where there is one'
};

/** The Live data warning for a pick holding fabricated scenarios: they have no live customer, so they run Mocked. */
export const fabricatedRunsMocked = (mode: RunMode, fabricated: number): string | null =>
	mode === 'grounded' && fabricated > 0
		? fabricated === 1
			? 'The fabricated scenario has no live customer, so it runs on Mocked data.'
			: `The ${counted(fabricated, 'fabricated scenario')} have no live customer, so they run on Mocked data.`
		: null;
